// shared/components/Layout/TopBar.tsx
export default function TopBar() {
  return (
    <header className="h-14 flex items-center justify-end bg-neon_purple-1000 border-b border-neutral-900 px-6 text-neutral-200 ">
      {/* Intentionally left empty (no Docs link or avatar) */}
    </header>
  );
}